import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class SalesAgentService {
	private readonly uri: string = environment.DO_URL;

	constructor(private readonly http: HttpClient) {}

	// Application CRUD operations
	getSalesAgents(): Observable<any> {
		return this.http.get(`${this.uri}/v2/sales-agents`);
	}
}
